import {ERROR_DEFAULT} from 'features/common/core/errors'
import api from 'features/common/transport'
import z from 'zod'

const sendCodeResponseSchema = z.object({
    valid: z.boolean(),
})

const checkCode = async (args: {email: string; code: string}) => {
    const res = await api
        .post('verification/email/checkCode', {body: JSON.stringify(args)})
        .json()

    const parseRes = sendCodeResponseSchema.safeParse(res)
    if (parseRes.success) {
        if (parseRes.data.valid) {
            return parseRes.data
        }

        throw new Error('ERROR_EMAIL_CODE_NOT_VALID')
    }

    return new Error(ERROR_DEFAULT)
}

export default checkCode
